import React from 'react'
import NavBar from '../components/Home/NavBar';
import CreateAccount from '../components/CreateAccount/CreateAccount';

const Create = () => {
  return (
    <div className='bg-bgSteps h-screen'>
        <NavBar />
        <CreateAccount />
    </div>
  )
}

export default Create